export default {
  'mission.title': 'Quản lý Nhiệm vụ',
  'mission.tabs.rewards': 'Phần thưởng nhiệm vụ',
  'mission.tabs.configs': 'Cấu hình hệ thống (Popup, URL)',
  'mission.alert.title': 'Trung tâm Cấu hình',
  'mission.alert.desc': 'Quản lý các tham số vận hành hệ thống như nội dung Popup, URL và các tham số Logic.',
  'mission.col.mission': 'Nhiệm vụ',
  'mission.col.desc': 'Mô tả',
  'mission.col.reward': 'Thưởng',
  'mission.col.status': 'Trạng thái',
  'mission.col.action': 'Thao tác',
  'mission.col.key': 'Khóa (Key)',
  'mission.col.value': 'Giá trị',
  'mission.btn.edit': 'Sửa',
  'mission.btn.cancel': 'Hủy',
  'mission.btn.save': 'Lưu lại',
  'mission.btn.update': 'Cập nhật',
  'mission.drawer.reward.title': 'Cấu hình Phần thưởng',
  'mission.drawer.config.title': 'Cập nhật Cấu hình',
  'mission.form.rewardValue': 'Giá trị phần thưởng (COWe)',
  'mission.form.required': 'Vui lòng nhập số lượng',
  'mission.form.activeStatus': 'Trạng thái hoạt động',
  'mission.form.on': 'Đang bật',
  'mission.form.off': 'Đang tắt',
  'mission.form.systemKey': 'Khóa hệ thống',
  'mission.form.copySuccess': 'Đã copy key!',
  'mission.form.noDesc': 'Không có mô tả',
  'mission.form.switchValue': 'Giá trị Switch (Bật/Tắt)',
  'mission.form.configContent': 'Nội dung cấu hình',
  'mission.form.valueRequired': 'Vui lòng nhập giá trị',
  'mission.form.jsonStructure': 'CẤU TRÚC JSON (CHỈ SỬA GIÁ TRỊ)',
  'mission.msg.loadError': 'Lỗi khi tải dữ liệu',
  'mission.msg.updateSuccess': 'Cập nhật thành công',
  'mission.msg.updateError': 'Lỗi khi cập nhật',
  'mission.msg.toggleSuccess': 'Đã {status} nhiệm vụ {key}',
};
